//@ts-nocheck
import {PendingTransactionResult, TransactionResult} from "./transaction-result";
import {forkJoin, Observable, of} from "rxjs";
import {catchError, last} from "rxjs/operators";
import {createChannel} from "../commons";

export class Transaction {
  public readonly channel: string;

  protected pending: PendingTransactionResult;
  protected results: Array<TransactionResult>;
  public observable: Observable<TransactionResult | TransactionResult[]>;

  protected doneListener;
  protected progressListener;
  protected cancelListener;


  constructor(socket: SocketIOClient.Socket) {
    this.channel = createChannel();
    const self = this;

    this.doneListener = function (someChannel, data) {
      if (someChannel === self.channel) {
        self.pending.done(data);
      }
    };

    this.progressListener = function (someChannel, data) {
      if (someChannel === self.channel) {
        self.pending.progress(data);
      }
    };

    this.cancelListener = function (someChannel, data) {
      if (someChannel === self.channel) {
        self.pending.cancel(data);
      }
    };

    socket.on('tx.done', this.doneListener);
    socket.on('tx.progress', this.progressListener);
    socket.on('tx.cancel', this.cancelListener);
  }
}

export class SingleTargetTransaction extends Transaction {
  public observable: Observable<TransactionResult>;

  constructor(target, options, socket: SocketIOClient.Socket) {
    super(socket);
    const result: TransactionResult = options.result(target);
    this.pending = new PendingTransactionResult(result);
    this.results = [result];


    const obs = this.pending.subject;

    obs.subscribe(
      () => {},
      () => {},
      () => {
        socket.removeListener('tx.done', this.doneListener);
        socket.removeListener('tx.progress', this.progressListener);
        socket.removeListener('tx.cancel', this.cancelListener);
        socket.emit('tx.cleanup', this.channel);
      }
    );

    this.observable = obs.pipe(last());
  }
}

export class MultiTargetTransaction extends Transaction {
  public observable: Observable<TransactionResult[]>;

  constructor(targets: Array<any>, options, socket: SocketIOClient.Socket) {
    super(socket);
    this.pending = Object.create(null);
    this.results = [];

    const res = targets.map(target => {
      const result: TransactionResult = options.result(target);
      const pendingResult: PendingTransactionResult = new PendingTransactionResult(result);
      this.pending[options.id ? target[options.id] : target.id] = pendingResult;
      this.results.push(result);
      return pendingResult.subject.pipe(catchError(() => {
        return of(pendingResult.result);
      }));
    });

    const obs = forkJoin(res);

    obs.subscribe(
      () => {},
      () => {},
      () => {
        socket.removeListener('tx.done', this.doneListener);
        socket.removeListener('tx.progress', this.progressListener);
        socket.removeListener('tx.cancel', this.cancelListener);
        socket.emit('tx.cleanup', this.channel);
      }
    );

    this.observable = obs.pipe(last());
  }
}
